import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Reducers
import { 
  AdminReducers,
  OrderReducers,
  CustomerReducers,
  CourierReducers,
  CartReducer
} from './reducers'

// Combine Reducers
const rootReducer = combineReducers({
  admin: AdminReducers,
  orders: OrderReducers,
  customers: CustomerReducers,
  couriers: CourierReducers,
  cart: CartReducer,
});

// Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ['admin'], // Only persist specific reducers
};

// Create Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for async storage
      immutableCheck: false,
    }),
  devTools: true, // Enable Redux DevTools for debugging
});

// Create Persistor
const persistor = persistStore(store);

export { store, persistor };
